import { Element } from '../../common/html/element'
import { LinkComponent } from '../../dashboard/common/html/LinkComponent'
import { COMPONENTS } from '../../routers/constants'
import ItemsInformation from '../common/ItemsInformation'
import classes from '../index.module.scss'

const renderItem = (values, el) => {
  return <div style={{ paddingBottom: 4 }}>{el}</div>
}

const ItemCompany = ({ item, index, isSimilar }) => {
  const {
    id,
    companyName,
    industry,
    size,
    yearsOfOperation,
    creditRisk,
    performance,
    purchasedReport,
    addedPortfolio,
    views,
  } = item

  const renderSimilar = () => {
    return (
      <>
        {renderItem(
          [size, yearsOfOperation],
          <ItemsInformation
            data={[
              { title: 'cartAndOrders.orderConfirmation.size', value: size },
              {
                title: 'cartAndOrders.orderConfirmation.year',
                value: yearsOfOperation,
              },
            ]}
          />,
        )}
        {renderItem(
          [creditRisk, performance],
          <ItemsInformation
            data={[
              {
                title: 'cartAndOrders.orderConfirmation.credit',
                value: creditRisk,
              },
              {
                title: 'cartAndOrders.orderConfirmation.performance',
                value: performance,
              },
            ]}
          />,
        )}
      </>
    )
  }

  const renderMostPopular = () => {
    return (
      <>
        {renderItem(
          [creditRisk, performance],
          <ItemsInformation
            data={[
              {
                title: 'cartAndOrders.orderConfirmation.credit',
                value: creditRisk,
              },
              {
                title: 'cartAndOrders.orderConfirmation.performance',
                value: performance,
              },
            ]}
          />,
        )}
        {renderItem(
          [purchasedReport, addedPortfolio, views],
          <ItemsInformation
            data={[
              {
                title: 'cartAndOrders.orderConfirmation.purcharsed',
                value: purchasedReport,
              },
              {
                title: 'cartAndOrders.orderConfirmation.addPort',
                value: addedPortfolio,
              },
              {
                title: 'cartAndOrders.orderConfirmation.views',
                value: views,
              },
            ]}
          />,
        )}
      </>
    )
  }

  return (
    <Element
      style={{ backgroundColor: index % 2 ? '#F9F9F9' : undefined }}
      className={classes.itemCompany}
    >
      <LinkComponent
        href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${id}`}
      >
        <Element className="fw600" style={{ color: '#2C73E8' }}>
          {companyName}
        </Element>
      </LinkComponent>
      <div className="mt1">
        {renderItem(
          [industry],
          <ItemsInformation
            data={[
              {
                title: 'cartAndOrders.orderConfirmation.industry',
                value: industry,
              },
            ]}
          />,
        )}
        <> {isSimilar ? renderSimilar() : renderMostPopular()}</>
      </div>
    </Element>
  )
}

export default ItemCompany
